<!--<hc-city-map-property *ngIf="form.controls['key'].value === 'cityMap'"
                      (dataChange)="onDataChanged($event)"
                      [data]="form.controls['value'].value"></hc-city-map-property>-->

<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; scope: 'delivery-zones'; read: 'deliveryZones'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.brandId')}}</nz-form-label>
          <nz-form-control>
            <hx-brand-select formControlName="brandId"></hx-brand-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.cityId')}}</nz-form-label>
          <nz-form-control>
            <hx-city-select formControlName="cityId"></hx-city-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.fromDate')}}</nz-form-label>
          <nz-form-control>
            <nz-date-picker formControlName="fromDate"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <hc-city-map-property *ngIf="form.controls.cityId.value && form.controls.brandId.value && form.controls.fromDate.value"
                          [cityId]="form.controls.cityId.value"
                          [brandId]="form.controls.brandId.value"
                          [date]="form.controls.fromDate.value"
                          [data]="$any(model)?.zone" (dataChange)="onZoneChanged($event)"></hc-city-map-property>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
